<template>
    <div>
      <!-- Slot to render on-page warning -->
      <slot v-if="somethingDirty" name="warning"></slot>
      <ModalComponent v-if="showModal" :show-close="false">
        <div slot="body">
          <div  class="regicall-alert-dirty">
              <!-- Slot to render a modal in -->
              <!-- Example: 
                <p>Modal question</p>
                <button @click="scope.accept">OK</button>
                <button @click="scope.cancel">Cancel</button> 
              -->
            <slot v-if="showModal" name="body"></slot>
          </div>
        </div>
        <div slot="footer">
          <slot name="footer" :accept="accept" :cancel="cancel"></slot>
        </div>
      </ModalComponent>
    </div>
</template>

<script>
  import ModalComponent from '../../../components/ModalComponent';

  export default {
    components: {
      ModalComponent
    },
    props: {
      alertText: {
        type: String,
        required: true
      },
      dirtyFlag: {
        type: String,
        required: true
      },
      instance: {
        type: Object,
        required: false
      },
      instances: {
        type: Array,
        required: false
      }
    },
    beforeMount () {
      this.$router.beforeHooks.push(this.beforeRouteLeave);
      window.addEventListener('beforeunload', this.beforeUnload);
    },
    beforeDestroy () {
      const hooks = this.$router.beforeHooks;
      hooks.splice(hooks.indexOf(this.beforeRouteLeave));
      window.removeEventListener('beforeunload', this.beforeUnload);
    },
    data () {
      return {
        showModal: false,
        next: null
      };
    },
    computed: {
      isDirty () {
        if (this.instance) {
          return this.instance[this.dirtyFlag];
        }
      },
      areDirty () {
        if (this.instances) {
          return this.instances.filter((instance) => {
            return instance && instance[this.dirtyFlag];
          }).length > 0;
        }
      },
      somethingDirty () {
        return this.isDirty || this.areDirty;
      }
    },
    methods: {
      beforeRouteLeave (to, from, next) {
        if (this.somethingDirty) {
          this.showModal = true;
          this.next = next;
        } else {
          next();
        }
      },
      beforeUnload (event) {
        if (this.somethingDirty) {
          // Cancel the event as stated by the standard.
          event.preventDefault();
          // Chrome requires returnValue to be set.
          event.returnValue = '';
          // Return the desired text, but this rarely used by the browser
          return this.alertText;
        }
      },
      accept () {
        this.showModal = false;
        this.next();
        this.$emit('dirtyAlertAccepted');
      },
      cancel () {
        this.showModal = false;
        this.$emit('dirtyAlertCanceled');
      }
    }
  };
</script>
